import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import {
	ModalDismissReasons,
	NgbModal,
	NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";

@Component({
  selector: 'app-verifyqrcode',
  templateUrl: './verifyqrcode.component.html',
  styleUrls: ['./verifyqrcode.component.scss']
})
export class VerifyqrcodeComponent implements OnInit {
  apiUrl: string; 
  status: boolean = false;
  dtOptions: any = {};
  submitted = false; 
 
  outboundForm: FormGroup;
  uniqueForm: FormGroup;
  testDetails: any;
  passportNumber: any;
  travelType: any;
  qrcode: string;
  inboundForm: FormGroup;
  modalOptions: NgbModalOptions;
  closeResult: string;
  modalRef: any;  

  constructor(private formBuilder: FormBuilder,
    private http: HttpClient,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService
    ) { }
  ngOnInit() {
    this.modalOptions = {
			backdrop: true,
			centered: true,
			backdropClass: 'customBackdrop',
			size: 'md',
		};
    this.inituniqueForm()

  }

  
  inituniqueForm(){
    this.uniqueForm = this.formBuilder.group({ 
      qrcode: ["", [Validators.required ]],
    });
  }
  
  initPositiveForm(data){}
  initNegativeForm(data){}

  viewModal(modal){
    this.showModal(modal);

  }

  submitForm(formData){
    this.submitted = true

    if(this.uniqueForm.invalid){
     return  
    }

    this.getUserDetails()
    this.submitted =false
  }

  getUserDetails() {
    let obj = {}; 
    this.qrcode = this.uniqueForm.get("qrcode").value
      this.spinnerService.show(); 
        this.apiUrl =
          environment.AUTHAPIURL +
          "passenger-get-record/" +
          this.qrcode;

        this.http.get<any>(this.apiUrl).subscribe((data) => {
          console.log("userDetails: ", data);
          if (data.status == true) {
            this.testDetails = data.response; 
            this.spinnerService.hide();
            
            if(this.travelType == 2){
              this.initPositiveForm(
                this.testDetails 
              ); 
              document.getElementById('loadPositiveModal').click()
            
            }else{
              this.initNegativeForm(
                this.testDetails 
              ); 
              document.getElementById('loadNegativeModal').click()
            }
          } else {
            Swal.fire({
              icon: "info",
              title: "Success",
              text: data.message,
              showConfirmButton: true,
              timer: 4000,
            }); 
            this.spinnerService.hide();
          }
        });
       
  }
  
	showModal(modal) {
		this.modalService.open(modal, this.modalOptions).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			}
		);
	} 

  private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}

}
